var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNoStoriesIllustration = function SvgNoStoriesIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 201,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.115 69.39c-3.234-5.6-10.396-7.52-15.997-4.286l-9.544 20.285h21.255c5.601-3.234 7.52-10.397 4.286-15.998Z",
    fill: "#F1F5F9",
    stroke: "#94A3B8",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M213.229 41.675 181.957 59.73M224.923 102.918l-34.879-9.346M166.08 1l-9.346 34.88",
    stroke: "#94A3B8",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.535 144.782c-4.018-7.447-6.286-25.332 16.781-37.298 1.031-.535 2.074-1.072 3.127-1.615 25.055-12.91 55.459-28.575 58.435-78.482.31-5.197 7.919-7.432 10.522-2.922l59.765 103.515c2.604 4.51-3.136 9.982-7.792 7.652-44.708-22.376-73.478-3.878-97.185 11.365-.996.64-1.983 1.275-2.962 1.901-21.896 13.994-36.25 3.086-40.691-4.116Z",
    fill: "#F1F5F9",
    stroke: "#94A3B8",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m69 151.338 28.077 35.304a7.078 7.078 0 0 0 7.102 2.497c4.65-1.053 6.949-6.311 4.565-10.44L86.71 140.535 69 151.338Z",
    fill: "#F1F5F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m63.66 100.611 23.05 39.924m0 0 22.034 38.164c2.384 4.129.085 9.387-4.565 10.44v0c-2.65.6-5.41-.37-7.102-2.497L69 151.338l17.71-10.803Z",
    stroke: "#94A3B8",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.139 134.2a1 1 0 0 0-1.732 1l1.732-1Zm-5.986 15.543a1 1 0 1 0 1 1.732l-1-1.732Zm4.254-14.543.734 1.271 1.732-1-.734-1.271-1.732 1Zm-2.56 13.565-1.694.978 1 1.732 1.693-.978-1-1.732Zm3.294-12.294a9 9 0 0 1-3.295 12.294l1 1.732c5.262-3.037 7.064-9.765 4.027-15.026l-1.733 1Z",
    fill: "#94A3B8"
  })));
};
export default SvgNoStoriesIllustration;